import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "columns is-mobile is-gapless is-vcentered mx-auto" }
const _hoisted_2 = {
  key: 0,
  class: "column is-narrow"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "column" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "column is-narrow"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide = _resolveComponent("slide")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isMultipleImages)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
              class: "navigationBtn material-icons is-size-6-mobile is-size-3-tablet",
              disabled: _ctx.currentSlide === 0
            }, "keyboard_arrow_left", 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_carousel, {
          ref: "carousel",
          modelValue: _ctx.currentSlide,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentSlide) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagesList, (img, index) => {
              return (_openBlock(), _createBlock(_component_slide, {
                key: index,
                onClick: ($event: any) => (_ctx.onImageClick(img)),
                class: "px-1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: img,
                    class: _normalizeClass(["image main-image", {'is-clickable': _ctx.isImageClickable}])
                  }, null, 10, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_ctx.isMultipleImages)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
              class: "navigationBtn material-icons is-size-6-mobile is-size-3-tablet",
              disabled: _ctx.currentSlide === (_ctx.images.length - 1)
            }, "keyboard_arrow_right", 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isMultipleImages && _ctx.withThumbnails)
      ? (_openBlock(), _createBlock(_component_Carousel, {
          key: 0,
          class: "thumbnails mx-auto mb-2",
          "items-to-show": _ctx.imagesList?.length,
          modelValue: _ctx.currentSlide,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentSlide) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagesList, (img, index) => {
              return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.slideTo(index)),
                    class: "is-clickable p-2"
                  }, [
                    _createElementVNode("img", {
                      src: img,
                      width: "60px",
                      height: "60px"
                    }, null, 8, _hoisted_9)
                  ], 8, _hoisted_8)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["items-to-show", "modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}